import * as languages from "../../constants/languages";
import browserHistory from "react-router/lib/browserHistory";
import { register } from "../../api/auth";
import { css } from "aphrodite";
import { english, spanish } from "../../constants/strings";
import loginStyles from "../../styles/loginStyles";
import LoggedOutPage from "../LoggedOutPage";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class SignUpPage extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		redirectPath: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = { error: null, email: "", email2: "" };
	}

	_setEmail = email => {
		this.setState({
			email,
			error: null,
		});
	};

	_setEmail2 = email2 => {
		this.setState({
			email2,
			error: null,
		});
	};

	_signup = e => {
		e.preventDefault();
		if (this.state.email !== this.state.email2) {
			this.setState({
				error: this.strings.errors.matchEmails,
			});

			return;
		}

		register(this.state.email, this.props.language)
			.then(() => {
				browserHistory.push(
					`/thanks${this.props.language || this.props.redirectPath ? "?" : ""}${
						this.props.language ? `language=${this.props.language}` : ""
					}${this.props.language && this.props.redirectPath ? "&" : ""}${
						this.props.redirectPath
							? `redirectpath=${encodeURIComponent(this.props.redirectPath)}`
							: ""
					}`,
				); // add language, redirect
				window.location.reload();
			})
			.catch(err => {
				if (err.response && err.response.status === 400) {
					let errMessage;
					if (
						err.response.data &&
						err.response.data.errors &&
						err.response.data.errors.email &&
						err.response.data.errors.email.length
					) {
						errMessage = err.response.data.errors.email[0];
					} else {
						errMessage = this.strings.errors.existingAccount;
					}

					this.setState({
						error: errMessage,
					});
				} else {
					this.setState({
						error: this.strings.errors.registerFailed,
					});
				}
			});
	};

	render() {
		return (
			<LoggedOutPage
				pageTitle={this.strings.SIGN_UP}
				language={this.props.language}
				currentRoute={this.props.pathname}
			>
				<form className={css(loginStyles.form)}>
					<div className={css(loginStyles.formItem)}>
						<label htmlFor="email" className={css(loginStyles.label)}>
							{this.strings.EmailAddress}
						</label>
						<input
							className={css([
								loginStyles.input,
								this.state.error ? loginStyles.inputError : "",
							])}
							id="email"
							type="text"
							value={this.state.email}
							onChange={e => this._setEmail(e.target.value)}
						/>
					</div>
					<div className={css(loginStyles.formItem)}>
						<label htmlFor="reenter-email" className={css(loginStyles.label)}>
							{this.strings.reenterEmail}
						</label>
						<input
							className={css([
								loginStyles.input,
								this.state.error ? loginStyles.inputError : "",
							])}
							id="reenter-email"
							type="text"
							value={this.state.email2}
							onChange={e => this._setEmail2(e.target.value)}
						/>
					</div>
					<div className={css(loginStyles.errorMessage)}>{this.state.error}</div>
					<div className={css(loginStyles.buttonContainer)}>
						<button className={css(loginStyles.button)} onClick={this._signup}>
							{this.strings.SUBMIT}
						</button>
					</div>
				</form>
			</LoggedOutPage>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/SignUpPage.js